import type { KeyboardInputBinding } from "./InputBinding/KeyboardInputBinding.type"
import { InputBindingDevice } from "./InputBindingDevice.enum"
import type { KeyCode } from "./KeyCode.type"

export default function createKeyboardBinding (
  code: KeyCode,
  shift?: boolean,
  ctrl?: boolean,
  alt?: boolean,
): KeyboardInputBinding {
  return {
    device: InputBindingDevice.Keyboard,
    code,
    shift,
    ctrl,
    alt,
  }
}